<template>
  <div class="audio-component-wrap has-no-style" :id="'audio' + Object.values(myid).join('')">
    <div class="audio-component style-wrap" @click.stop.prevent :style="getAudioStyle">
      <div class="audio-container" ref="audioInner" v-if="!showControls">
        <img
          :src="iconPauseSrc"
          alt=""
          class="audio-puase icon"
          v-if="isAudioStop"
          @click="audioPause('myAudio' + Object.values(myid).join(''))"
        />
        <img
          :src="iconPlaySrc"
          alt=""
          class="audio-play icon"
          v-else
          @click="audioPlay('myAudio' + Object.values(myid).join(''))"
        />
        <audio :loop="loopPlay" :autoplay="autoplayStatus" :id="'myAudio' + Object.values(myid).join('')">
          <source :src="audioSrc" />
        </audio>
      </div>
      <div class="audio-container" ref="audioInner" v-else>
        <audio
          :loop="loopPlay"
          :autoplay="autoplayStatus"
          :id="'myAudio' + Object.values(myid).join('')"
          ref="controlsAudio"
          @timeupdate="updateProgress"
        >
          <source :src="audioSrc" />
        </audio>
        <div class="custom-audio">
          <div :style="silerStyle">
            <el-slider
              v-model="percentage"
              @change="progressChange"
              id="progressBar"
              :show-tooltip="false"
              :disabled="disabled"
            ></el-slider>
          </div>
          <div class="audio-time" :style="timeStyle">
            <span class="audio-length-current">{{ currentTime }}</span>
            <span class="audio-length-total">{{ duration }}</span>
          </div>
          <div class="btn-box" :style="imgStyle">
            <img
              v-if="isAudioStop"
              :src="iconPauseSrc"
              alt=""
              class="audio-puase icon"
              @click="audioPause('myAudio' + Object.values(myid).join(''))"
            />
            <img
              v-else
              :src="iconPlaySrc"
              alt=""
              class="audio-play icon"
              @click="audioPlay('myAudio' + Object.values(myid).join(''))"
            />
            <img
              :src="iconBackSrc"
              alt=""
              class="icon"
              @click="audioSpeed('myAudio' + Object.values(myid).join(''), 2)"
            />
            <img
              :src="iconFastSrc"
              alt=""
              class="icon"
              @click="audioSpeed('myAudio' + Object.values(myid).join(''), 1)"
            />
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import audioDefaultPlay from "assets/images/icon-play.png"
import audioDefaultPause from "assets/images/icon-pause.png"
import eventMixin from "utils/event/eventMixin.js"
import dataRenderMixin from "materials/dataRenderMixin"

export default {
  mixins: [eventMixin, dataRenderMixin],
  name: "cxAudio",
  props: {
    options: {
      type: Object,
      default: null
    },
    myid: {
      type: Object,
      default: null
    }
  },
  data() {
    return {
      myplayer: null,
      isAudioStop: false,
      myAudio: null,
      _timer: null,
      currentTime: "0:00",
      duration: "0:00",
      percentage: 0,
      disabled: true
    }
  },
  mounted() {
    this.isAudioStop = this.options.autoplayStatus && this.options.audioUrl
    this._timer = setTimeout(() => {
      this.myAudio = document.getElementById("myAudio" + Object.values(this.myid).join(""))
      if (this.options.audioUrl && this.options.autoplayStatus) {
        this.myAudio.load()
        this.myAudio.play()
      }
      this.fetch()
    }, 500)
  },
  destroyed() {
    this._timer && clearTimeout(this._timer)
  },
  computed: {
    audioSrc() {
      // this.options.objectId = "3e21976a7d253413370eab218e6011ab"
      if (this.options.objectId) {
        let that = this
        async function getAudioUrl() {
          const objectId = that.options.objectId
          let ypDataUrl = "//yp.mh.chaoxing.com/upload/yunpan/" + objectId + "/status"
          let url = await that.instance.get(ypDataUrl).then(res => {
            //异步函数 数据改变了还会进来
            if (objectId === "" || objectId !== that.options.objectId) {
              return 
            }
            that.myAudio = document.getElementById("myAudio" + Object.values(that.myid).join(""))
            that.myAudio.src = res.data.http
            that.myAudio.load()
            that.$changeOptionsEV(res.data.filename, "audioName", false)
            return res.data.http
          })
          return url
        }
        return getAudioUrl()
      } else {
        return this.options.audioUrl ? this.options.audioUrl : ""
      }
    },
    iconPlaySrc() {
      return this.options.iconPlaySrc ? this.options.iconPlaySrc : audioDefaultPlay
    },
    iconPauseSrc() {
      return this.options.iconPauseSrc ? this.options.iconPauseSrc : audioDefaultPause
    },
    iconFastSrc() {
      return this.options.iconFastSrc ? this.options.iconFastSrc : ""
    },
    iconBackSrc() {
      return this.options.iconBackSrc ? this.options.iconBackSrc : ""
    },
    loopPlay() {
      return this.options.loopPlay
    },
    autoplayStatus() {
      return this.options.autoplayStatus
    },
    boxShadowStyle() {
      let tmpStyle = ""
      let _this = this
      if (Array.isArray(this.options.boxShadowH)) {
        this.options.boxShadowH.forEach((item, index) => {
          if (index > 0) {
            tmpStyle += ","
          }
          tmpStyle += `${_this.options.boxShadowH[index]}px ${_this.options.boxShadowV[index]}px ${_this.options.boxShadowBlur[index]}px ${_this.options.boxShadowSpread[index]}px ${this.$parseColor(_this.options.boxShadowColor[index])}`
        })
      } else {
        tmpStyle += `${this.options.boxShadowH}px ${this.options.boxShadowV}px ${this.options.boxShadowBlur}px ${this.options.boxShadowSpread}px ${this.$parseColor(this.options.boxShadowColor)}`
      }
      return tmpStyle
    },
    bgStyle() {
      let containerBg = {
        backgroundImage: ""
      }
      let curBackground = this.options.background
      if (
        !curBackground ||
        !Array.isArray(curBackground) ||
        (Array.isArray(curBackground) && curBackground.length === 0)
      ) {
        curBackground = [
          {
            type: "color",
            label: "颜色",
            isThemeColor: this.options.hasOwnProperty("bgColorIsThemeColor") ? this.options.bgColorIsThemeColor : false,
            color: this.options.bgColor
          }
        ]
      }
      curBackground.forEach(bg => {
        switch (bg.type) {
          case "img":
            let dot1 = containerBg.backgroundImage.length > 0 ? "," : ""
            containerBg.backgroundImage += `${dot1}url(${bg.imgUrl})`
            containerBg.backgroundSize =containerBg.backgroundSize?`${containerBg.backgroundSize},${bg.clipSize}`:`${bg.clipSize}`
            containerBg.backgroundPosition = containerBg.backgroundPosition?`${containerBg.backgroundPosition},${bg.alignType}`:`${bg.alignType}`
            containerBg.backgroundRepeat = containerBg.backgroundRepeat?`${containerBg.backgroundRepeat},${bg.repeatType}`:`${bg.repeatType}`
            break
          case "color":
            containerBg.backgroundColor = this.$parseColor(bg)
            break
          case "linearGradient":
            let tmp = []
            if (bg.data.stops.length > 0) {
              bg.data.stops.forEach(item => {
                tmp.push(item[0] + " " + item[1] * 100 + "%")
              })
              let dot = containerBg.backgroundImage.length > 0 ? "," : ""
              containerBg.backgroundImage += dot + this.$parseColor(bg)
              containerBg.backgroundSize =containerBg.backgroundSize?`${containerBg.backgroundSize},auto`:`auto`
              containerBg.backgroundPosition = containerBg.backgroundPosition?`${containerBg.backgroundPosition},center`:`center`
              containerBg.backgroundRepeat = containerBg.backgroundRepeat?`${containerBg.backgroundRepeat},no-repeat`:`no-repeat`
            }
            break
          case "radialGradient":
            let radialTmp = []
            if (bg.data.stops.length > 0) {
              bg.data.stops.forEach(item => {
                radialTmp.push(item[0] + " " + item[1] * 100 + "%")
              })
              let dot = containerBg.backgroundImage.length > 0 ? "," : ""
              containerBg.backgroundImage +=
                dot + this.$parseColor(bg)
              containerBg.backgroundSize = containerBg.backgroundSize ? `${containerBg.backgroundSize},auto` : `auto`
              containerBg.backgroundPosition = containerBg.backgroundPosition ? `${containerBg.backgroundPosition},center` : `center`
              containerBg.backgroundRepeat = containerBg.backgroundRepeat ? `${containerBg.backgroundRepeat},no-repeat` : `no-repeat`
            }
            break
          default:
        }
      })
      return containerBg
    },
    getAudioStyle() {
      let borderW = ""
      if (Array.isArray(this.options.borderWidth)) {
        this.options.borderWidth.forEach(item => [(borderW += ` ${item}px`)])
      } else {
        borderW += ` ${this.options.borderWidth}px`
      }
      return {
        transform: "rotate(" + this.options.rotate + "deg)",
        padding: this.options.legendPadding + "px",
        paddingTop: this.options.paddingTop + "px",
        paddingRight: this.options.paddingRight + "px",
        paddingBottom: this.options.paddingBottom + "px",
        paddingLeft: this.options.paddingLeft + "px",
        opacity: this.options.opacity / 100,
        "box-shadow": this.boxShadowStyle,
        "border-top-left-radius": this.options.borderTopLeftRadius + "px",
        "border-top-right-radius": this.options.borderTopRightRadius + "px",
        "border-bottom-right-radius": this.options.borderBottomRightRadius + "px",
        "border-bottom-left-radius": this.options.borderBottomLeftRadius + "px",
        "border-style": this.options.borderStyle,
        // "border-color": this.options.borderIsThemeColor
        //   ? this.themeColor
        //   : this.options.borderColor.color
        //   ? this.options.borderColor.color
        //   : this.options.borderColor,
        "border-color": this.$parseColor(this.options.borderColor, {
          isThemeColor: this.options.borderIsThemeColor
        }), 
        "border-width": borderW,
        ...this.bgStyle
      }
    },
    noCacheComponent() {
      return this.options && this.options.noCacheComponent ? this.options.noCacheComponent : false
    },
    showControls() {
      return this.options.showControls
    },
    barBgStyle() {
      let containerBg = {
        backgroundImage: ""
      }
      let curBackground = this.options.barBackground
      curBackground.forEach(bg => {
        switch (bg.type) {
          case "img":
            let dot1 = containerBg.backgroundImage.length > 0 ? "," : ""
            containerBg.backgroundImage += `${dot1}url(${bg.imgUrl})`
            containerBg.backgroundSize =containerBg.backgroundSize?`${containerBg.backgroundSize},${bg.clipSize}`:`${bg.clipSize}`
            containerBg.backgroundPosition = containerBg.backgroundPosition?`${containerBg.backgroundPosition},${bg.alignType}`:`${bg.alignType}`
            containerBg.backgroundRepeat = containerBg.backgroundRepeat?`${containerBg.backgroundRepeat},${bg.repeatType}`:`${bg.repeatType}`
            break
          case "color":
            // containerBg.backgroundColor = bg.isThemeColor
            //   ? this.$store.state[this.request_prefix].page.themeColor
            //   : bg.color
            containerBg.backgroundColor = this.$parseColor(bg)
            break
          case "linearGradient":
            let tmp = []
            if (bg.data.stops.length > 0) {
              bg.data.stops.forEach(item => {
                tmp.push(item[0] + " " + item[1] * 100 + "%")
              })
              let dot = containerBg.backgroundImage.length > 0 ? "," : ""
              // containerBg.backgroundImage += dot + "linear-gradient(" + bg.data.angle + "deg," + tmp.join(",") + ")"
              containerBg.backgroundImage += dot + this.$parseColor(bg)
              containerBg.backgroundSize =containerBg.backgroundSize?`${containerBg.backgroundSize},auto`:`auto`
              containerBg.backgroundPosition = containerBg.backgroundPosition?`${containerBg.backgroundPosition},center`:`center`
              containerBg.backgroundRepeat = containerBg.backgroundRepeat?`${containerBg.backgroundRepeat},no-repeat`:`no-repeat`
            }
            break
          case "radialGradient":
            let radialTmp = []
            if (bg.data.stops.length > 0) {
              bg.data.stops.forEach(item => {
                radialTmp.push(item[0] + " " + item[1] * 100 + "%")
              })
              let dot = containerBg.backgroundImage.length > 0 ? "," : ""
              // containerBg.backgroundImage +=
              //   dot + "radial-gradient(at " + bg.data.siteX + "% " + bg.data.siteY + "%," + radialTmp.join(",") + ")"
              containerBg.backgroundImage +=
                dot + this.$parseColor(bg)
              containerBg.backgroundSize = containerBg.backgroundSize ? `${containerBg.backgroundSize},auto` : `auto`
              containerBg.backgroundPosition = containerBg.backgroundPosition ? `${containerBg.backgroundPosition},center` : `center`
              containerBg.backgroundRepeat = containerBg.backgroundRepeat ? `${containerBg.backgroundRepeat},no-repeat` : `no-repeat`
            }
            break
          default:
        }
      })
      return containerBg
    },
    progressBgStyle() {
      let containerBg = {
        backgroundImage: ""
      }
      let curBackground = this.options.progressBackground
      curBackground.forEach(bg => {
        switch (bg.type) {
          case "img":
            let dot1 = containerBg.backgroundImage.length > 0 ? "," : ""
            containerBg.backgroundImage += `${dot1}url(${bg.imgUrl})`
            containerBg.backgroundSize =containerBg.backgroundSize?`${containerBg.backgroundSize},${bg.clipSize}`:`${bg.clipSize}`
            containerBg.backgroundPosition = containerBg.backgroundPosition?`${containerBg.backgroundPosition},${bg.alignType}`:`${bg.alignType}`
            containerBg.backgroundRepeat = containerBg.backgroundRepeat?`${containerBg.backgroundRepeat},${bg.repeatType}`:`${bg.repeatType}`
            break
          case "color":
            containerBg.backgroundColor = this.$parseColor(bg)
            break
          case "linearGradient":
            let tmp = []
            if (bg.data.stops.length > 0) {
              bg.data.stops.forEach(item => {
                tmp.push(item[0] + " " + item[1] * 100 + "%")
              })
              let dot = containerBg.backgroundImage.length > 0 ? "," : ""
              containerBg.backgroundImage += dot + this.$parseColor(bg)
              containerBg.backgroundSize =containerBg.backgroundSize?`${containerBg.backgroundSize},auto`:`auto`
              containerBg.backgroundPosition = containerBg.backgroundPosition?`${containerBg.backgroundPosition},center`:`center`
              containerBg.backgroundRepeat = containerBg.backgroundRepeat?`${containerBg.backgroundRepeat},no-repeat`:`no-repeat`
            }
            break
          case "radialGradient":
            let radialTmp = []
            if (bg.data.stops.length > 0) {
              bg.data.stops.forEach(item => {
                radialTmp.push(item[0] + " " + item[1] * 100 + "%")
              })
              let dot = containerBg.backgroundImage.length > 0 ? "," : ""
              containerBg.backgroundImage += dot + this.$parseColor(bg)
              containerBg.backgroundSize = containerBg.backgroundSize ? `${containerBg.backgroundSize},auto` : `auto`
              containerBg.backgroundPosition = containerBg.backgroundPosition ? `${containerBg.backgroundPosition},center` : `center`
              containerBg.backgroundRepeat = containerBg.backgroundRepeat ? `${containerBg.backgroundRepeat},no-repeat` : `no-repeat`
            }
            break
          default:
        }
      })
      return containerBg
    },
    thumbsBoxShadowStyle() {
      let tmpStyle = ""
      let _this = this
      if (Array.isArray(this.options.thumbsBoxShadowH)) {
        this.options.thumbsBoxShadowH.forEach((item, index) => {
          if (index > 0) {
            tmpStyle += ","
          }
          tmpStyle += `${_this.options.thumbsBoxShadowH[index]}px ${_this.options.thumbsBoxShadowV[index]}px ${_this.options.thumbsBoxShadowBlur[index]}px ${_this.options.thumbsBoxShadowSpread[index]}px ${this.$parseColor(_this.options.thumbsBoxShadowColor[index])}`
        })
      } else {
        tmpStyle += `${this.options.thumbsBoxShadowH}px ${this.options.thumbsBoxShadowV}px ${this.options.thumbsBoxShadowBlur}px ${this.options.thumbsBoxShadowSpread}px ${this.$parseColor(this.options.thumbsBoxShadowColor)}`
      }
      return tmpStyle
    },
    themeColor() {
      return this.$store.state[this.request_prefix].page.themeColor
    },
    silerStyle() {
      let barBorderW = ""
      if (Array.isArray(this.options.barBorderWidth)) {
        this.options.barBorderWidth.forEach(item => [(barBorderW += ` ${item}px`)])
      } else {
        barBorderW += ` ${this.options.barBorderWidth}px`
      }
      let thumbsBorderW = ""
      if (Array.isArray(this.options.thumbsBorderWidth)) {
        this.options.thumbsBorderWidth.forEach(item => [(thumbsBorderW += ` ${item}px`)])
      } else {
        thumbsBorderW += ` ${this.options.thumbsBorderWidth}px`
      }
      return {
        "--bar-background-color": this.$parseColor(this.barBgStyle.backgroundColor),
        "--bar-background-image": this.barBgStyle.backgroundImage,
        "--bar-background-position": this.barBgStyle.backgroundPosition,
        "--bar-background-repeat": this.barBgStyle.backgroundRepeat,
        "--bar-background-size": this.barBgStyle.backgroundSize,
        "--bar-height": this.options.progressbarHeight + "px",
        "--bar-border-top-left-radius": this.options.barBorderTopLeftRadius + "px",
        "--bar-border-top-right-radius": this.options.barBorderTopRightRadius + "px",
        "--bar-border-bottom-right-radius": this.options.barBorderBottomRightRadius + "px",
        "--bar-border-bottom-left-radius": this.options.barBorderBottomLeftRadius + "px",
        "--bar-border-style": this.options.barBorderStyle,
        "--bar-border-color": this.$parseColor(this.options.barBorderColor, {
          isThemeColor: this.options.barBorderIsThemeColor
        }),
        "--bar-border-width": barBorderW,
        "--progress-background-color": this.$parseColor(this.progressBgStyle.backgroundColor),
        "--progress-background-image": this.progressBgStyle.backgroundImage,
        "--progress-background-position": this.progressBgStyle.backgroundPosition,
        "--progress-background-repeat": this.progressBgStyle.backgroundRepeat,
        "--progress-background-size": this.progressBgStyle.backgroundSize,
        "--slider-size": this.options.symbolSize + "px",
        "--slider-bg-color": this.$parseColor(this.options.sliderIconColor, {
          isThemeColor: this.options.sliderIconIsThemeColor
        }),
        "--slider-box-shadow": this.thumbsBoxShadowStyle,
        "--slider-border-top-left-radius": this.options.thumbsBorderTopLeftRadius + "px",
        "--slider-border-top-right-radius": this.options.thumbsBorderTopRightRadius + "px",
        "--slider-border-bottom-right-radius": this.options.thumbsBorderBottomRightRadius + "px",
        "--slider-border-bottom-left-radius": this.options.thumbsBorderBottomLeftRadius + "px",
        "--slider-border-style": this.options.thumbsBorderStyle,
        "--slider-border-color": this.$parseColor(this.options.thumbsBorderColor, {
          isThemeColor: this.options.thumbsBorderIsThemeColor
        }),
        "--slider-border-width": thumbsBorderW
      }
    },
    timeStyle() {
      return {
        "font-size": this.options.otherFontSize + "px",
        "font-family": this.options.timeFontFamily,
        "font-weight": this.options.timeFontWeight,
        color: this.$parseColor(this.options.timeColor)
      }
    },
    imgStyle() {
      return {
        "--img-size": this.options.buttonIconSize + "px",
        "--img-margin": this.options.iconMargin + "px"
      }
    },
    filedMapping() {
      return this.options.filedMapping &&
        this.options.filedMapping.value !== null &&
        typeof this.options.filedMapping.value !== "undefined"
        ? true
        : false
    }
  },
  watch: {
    audioSrc(val) {
      this.myAudio = document.getElementById("myAudio" + Object.values(this.myid).join(""))
      this.myAudio.src = val
      this.myAudio.load()
      if (this.autoplayStatus && val) {
        this.isAudioStop = true
        this.myAudio.play()
      } else {
        this.isAudioStop = false
      }
    },
    "options.detailFieldMapping": {
      deep: true,
      handler(n, o) {
        if (n) {
          this.updateData()
        }
      }
    },
    // 非详情页的音频字段匹配
    "options.audioUrl": {
      deep: true,
      handler(n, o) {
        if (typeof n === "string" && this.filedMapping) {
          if (n.includes(".mp3")) {
            this.$changeOptionsEV("", "objectId", false, null, this.myid)
          } else {
            this.$changeOptionsEV(n, "objectId", false, null, this.myid)
          }
        }
      }
    }
  },
  methods: {
    async updateData() {
      this.updateNormalRect.call(this, data => {
        console.log("updateCb", data)
        if (typeof data === "string") {
          if (data.includes(".mp3")) {
            this.$changeOptionsEV(data, "audioUrl", false, null, this.myid)
            this.$changeOptionsEV("", "objectId", false, null, this.myid)
          } else {
            this.$changeOptionsEV(data, "objectId", false, null, this.myid)
          }
        }
      })
    },
    audioPlay(id) {
      if (this.entryAudioSrc) {
        this.isAudioStop = true
        document.getElementById(id).play()
      }
    },
    audioPause(id) {
      this.isAudioStop = false
      document.getElementById(id).pause()
    },
    audioSpeed(id, type) {
      let time = document.getElementById(id).currentTime
      if (type === 1) {
        time = time + 5 //快进
      }
      if (type === 2 && time != 0) {
        time = time - 5 //后退
      }
      document.getElementById(id).currentTime = time
      this.currentTime = this.transTime(time)
    },
    fetch() {
      let that = this
      var myVid = document.getElementById("myAudio" + Object.values(this.myid).join(""))
      if (this.myAudio && this.myAudio.duration) {
        this.duration = this.transTime(this.myAudio.duration)
        this.disabled = false
      }
    },
    // 更新进度条与当前播放时间
    updateProgress(e) {
      var value = e.target.currentTime / e.target.duration
      if (document.getElementById("progressBar")) {
        this.percentage = value * 100
      }
      this.currentTime = this.transTime(e.target.currentTime)
      // 1.初始化时没有获取到时长 2.重新上传时修改时长
      setTimeout(() => {
        if (e.target.duration && this.duration != this.transTime(e.target.duration)) {
          this.disabled = false
          this.duration = this.transTime(e.target.duration)
        }
      }, 500)
    },
    /**
     * 音频播放时间换算
     * @param {number} time - 音频当前播放时间，单位秒
     */
    transTime(time) {
      var duration = parseInt(time)
      var minute = parseInt(duration / 60)
      var sec = (duration % 60) + ""
      var isM0 = ":"
      if (minute === 0) {
        minute = "00"
      } else if (minute < 10) {
        minute = "0" + minute
      }
      if (sec.length === 1) {
        sec = "0" + sec
      }
      return minute + isM0 + sec
    },
    // 监听进度条改变
    progressChange(val) {
      if (!this.audioSrc || !this.myAudio.duration) return
      this.myAudio.currentTime = (this.myAudio.duration * val) / 100
      // this.myAudio.play() //播放
    }
  }
}
</script>

<style scoped>
.audio-component-wrap,
.audio-component {
  width: 100%;
  height: 100%;
}
.audio-container {
  width: 100%;
  height: 100%;
}
.audio-container .icon {
  width: 100%;
  height: 100%;
}

.custom-audio {
  width: 100%;
}
.custom-audio .btn-box {
  display: flex;
  justify-content: center;
}
.custom-audio .btn-box .icon {
  width: var(--img-size);
  height: var(--img-size);
  margin-left: var(--img-margin);
}
.custom-audio {
  width: 100%;
}
.custom-audio .btn-box {
  display: flex;
  justify-content: center;
}
.custom-audio .btn-box .icon {
  width: var(--img-size);
  height: var(--img-size);
  margin-left: var(--img-margin);
}
.custom-audio .btn-box .icon:first-child {
  margin-left: 0;
}
.custom-audio .audio-time {
  overflow: hidden;
  margin-top: 10px;
}
.audio-length-total {
  float: right;
}
.audio-length-current {
  float: left;
}
::v-deep .el-slider__runway {
  background-color: var(--bar-background-color);
  background-image: var(--bar-background-image);
  background-position: var(--bar-background-position);
  background-repeat: var(--bar-background-repeat);
  background-size: var(--bar-background-size);
  flex: 1;
  position: relative;
  height: var(--bar-height);
  cursor: pointer;
  border-width: var(--bar-border-width);
  border-style: var(--bar-border-style);
  border-color: var(--bar-border-color);
  border-radius: var(--bar-border-top-left-radius) var(--bar-border-top-right-radius)
    var(--bar-border-bottom-right-radius) var(--bar-border-bottom-left-radius);
}
::v-deep .el-slider__runway::before,
::v-deep .el-slider__runway::after {
  background: transparent !important;
}
::v-deep .el-slider__bar {
  background-color: var(--progress-background-color);
  background-image: var(--progress-background-image);
  background-position: var(--progress-background-position);
  background-repeat: var(--progress-background-repeat);
  background-size: var(--progress-background-size);
  width: 0%;
  height: var(--bar-height);
  border-radius: var(--bar-border-top-left-radius) var(--bar-border-top-right-radius)
    var(--bar-border-bottom-right-radius) var(--bar-border-bottom-left-radius);
}
::v-deep .el-slider__button-wrapper {
  top: 50%;
  transform: translate(-50%, -50%);
  width: var(--slider-size);
  height: var(--slider-size);
}
::v-deep .el-slider__button-wrapper .el-slider__button {
  width: var(--slider-size);
  height: var(--slider-size);
  background: var(--slider-bg-color);
  border-width: var(--slider-border-width);
  border-style: var(--slider-border-style);
  border-color: var(--slider-border-color);
  box-shadow: var(--slider-box-shadow);
  border-radius: var(--slider-border-top-left-radius) var(--slider-border-top-right-radius)
    var(--slider-border-bottom-right-radius) var(--slider-border-bottom-left-radius);
}
</style>
